// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__RTsLP","footer":"Form_footer__3vu_I"};